import { HTMLAttributes, useRef, useState } from 'react';
import { FormOption } from 'types';
import { EMPTY_OPTION } from 'commons';
import { SelectContext } from '../../contexts';

interface ComponentProps extends HTMLAttributes<HTMLElement> {
  initialSelected?: FormOption;
  initialTagged?: FormOption[];
}

export function SelectProvider({
  children,
  initialSelected = EMPTY_OPTION,
  initialTagged = [],
}: ComponentProps) {
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const [option, setOption] = useState<FormOption>(initialSelected);
  const [tagList, setTagList] = useState<FormOption[]>(initialTagged);
  const [inputText, setInputText] = useState<string>('');
  const [searchable, setSearchable] = useState<boolean>(false);

  const selectInputRef = useRef();

  return (
    <SelectContext.Provider
      value={{
        showOptions,
        setShowOptions,
        option,
        setOption,
        tagList,
        setTagList,
        inputText,
        setInputText,
        searchable,
        setSearchable,
        selectInputRef,
      }}
    >
      {children}
    </SelectContext.Provider>
  );
}
